export const TRANSCRIPT_CHUNK_DURATION = 30000; // 30 seconds

export enum AI_TRANSCRIPTION_MODELS {
    WHISPER_1 = "whisper-1",
}

export enum TranscriptViewMode {
    RAW = "raw",
    CHAT = "chat",
    RAW_CHAT = "raw_chat",
}

export const TRANSCRIPT_VIEW_MODE_SEARCH_VALUES = ["chat", "raw-chat", "raw"] as const;
export type TranscriptViewModeSearchParam = (typeof TRANSCRIPT_VIEW_MODE_SEARCH_VALUES)[number];

export const transcriptViewModeFromSearch = (value: TranscriptViewModeSearchParam | undefined): TranscriptViewMode => {
    switch (value) {
        case "raw-chat":
            return TranscriptViewMode.RAW_CHAT;
        case "raw":
            return TranscriptViewMode.RAW;
        default:
            return TranscriptViewMode.CHAT;
    }
};

export const transcriptViewModeToSearch = (mode: TranscriptViewMode): TranscriptViewModeSearchParam => {
    switch (mode) {
        case TranscriptViewMode.RAW_CHAT:
            return "raw-chat";
        case TranscriptViewMode.RAW:
            return "raw";
        default:
            return "chat";
    }
};

export enum TRANSCRIPT_STATUS {
    QUEUED = "queued",
    PROCESSING = "processing",
    PROCESSED = "processed",
    FAILED = "failed",
    INVALID = "invalid",
    /** @deprecated Legacy value still present in the database */
    COMPLETED = "completed",
    /** @deprecated Legacy value still present in the database */
    PENDING = "pending",
}

export const isTranscriptReady = (status: TRANSCRIPT_STATUS): boolean =>
    status === TRANSCRIPT_STATUS.PROCESSED || status === TRANSCRIPT_STATUS.COMPLETED;

export const isTranscriptInProgress = (status: TRANSCRIPT_STATUS): boolean =>
    status === TRANSCRIPT_STATUS.QUEUED ||
    status === TRANSCRIPT_STATUS.PROCESSING ||
    status === TRANSCRIPT_STATUS.PENDING;

export const isTranscriptTerminal = (status: TRANSCRIPT_STATUS): boolean =>
    isTranscriptReady(status) || status === TRANSCRIPT_STATUS.FAILED || status === TRANSCRIPT_STATUS.INVALID;
